import React from 'react'
import { FaHeart,FaUser } from "react-icons/fa";


const Sidebar = ({ username, setUsername,showOfp, setShowOfp }) => {
    return (
        <aside className="text-white lg:border-r sm:border-b flex lg:flex-col justify-between border-bordercolor w-full lg:w-80 sm:w-full lg:min-w-80 b-8 p-6">
            <div className=" w-full">
                <div className="flex justify-between mb-6 items-center h-12">
                    <h3 className="text-3xl font-light">
                        Your<span className="font-bold">EFB</span>
                    </h3>
                    {username && <button onClick={() => { setUsername(''); localStorage.removeItem('username') }} className="flex text-white w-12 h-12 justify-center items-center focus:outline-none bg-primary hover:opacity-90  transform transition-opacity duration-200"
                    
                    >
                        <FaUser className="z-10 fill-current"/>
                    </button>}
                </div>
                <div>
                    { username && (
                        <div className="flex  lg:flex-col lg:space-y-1 sm:space-y-0 lg:mb-5 mb-0 lg:space-x-0 sm:space-x-1">
                            <button onClick={() => { setShowOfp(!showOfp) }} className="flex w-full justify-center font-medium items-center  focus:outline-none h-16 bg-primary px-6 hover:opacity-90 transform transition-opacity duration-100">
                                {showOfp ? 'Hide OFP' : 'Show OFP'}
                            </button>
                            <a target="_BLANK" href="https://www.aviationweather.gov/metar/data?ids=&format=raw&date=&hours=0" className="flex w-full justify-center font-medium items-center  focus:outline-none h-16 bg-primary px-6 hover:opacity-90 transform transition-opacity duration-100">
                                Aviation Weather
                            </a>
                        </div>
                    ) }
                    {/* <a className="text-base font-semibold hover:text-primary transform transition-colors duration-500 shadow-sm">About YourEFB</a> */}
                </div>
            </div>
            <div>
                <h2 className="font-semibold flex-1 hidden lg:flex items-center justify-between">Made with <FaHeart />  and Serhat Gündoğdu</h2>
            </div>
        </aside>
        
    )
}

export default Sidebar
